module.exports = __webpack_public_path__ + "static/media/bg_page_14.37e2f3b9.jpg";